export interface DbNoteListeItem {
    id: string;
    omraade: string;
    antalbilag: string;
    overskrift: string;
    dato: string;
}
